/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Enum where the value is the cover.slug column
 * If there are any new items, be sure to update _COVER_TYPE_DISPLAY_NAMES at the same time
 */
export var CoverType;

(function (CoverType) {
  CoverType["PROFESSIONAL_INDEMNITY"] = "professional-indemnity";
  CoverType["GOODS_IN_TRANSIT"] = "goods-in-transit";
  CoverType["PUBLIC_LIABILITY"] = "public-liability";
  CoverType["EMPLOYERS_LIABILITY"] = "employers-liability";
  CoverType["DIRECTORS_OFFICERS"] = "directors-officers";
  CoverType["CORPORATE_LEGAL_LIABILITY"] = "corporate-legal-liability";
  CoverType["LEGAL_EXPENSES"] = "legal-expenses";
  CoverType["EMPLOYMENT_PRACTICES"] = "employment-practices";
  CoverType["CYBER_LIABILITY"] = "cyber-liability";
  CoverType["CYBER_CRIME"] = "cyber-crime";
  CoverType["CYBER_SECURITY"] = "cyber-security";
  CoverType["PROPERTY_COVER"] = "property-cover";
  CoverType["BUSINESS_HR_COVER"] = "business-hr-cover";
  CoverType["PORTABLE_EQUIPMENT"] = "portable-equipment";
  CoverType["IR35_INSURANCE"] = "ir35-insurance";
  CoverType["HIRED_IN_PLANT"] = "hired-in-plant";
  CoverType["HIRE_AND_REWARD"] = "hire-and-reward";
  CoverType["OCCUPATIONAL_PERSONAL_ACCIDENT"] = "occupational-personal-accident";
  CoverType["PRE_POWER_UNIT"] = "pre-power-unit";
  CoverType["RELOADING"] = "reloading";
  CoverType["DEBRIS_REMOVAL"] = "debris-removal";
  CoverType["EARNED_FREIGHT"] = "earned-freight";
  CoverType["FIRE_DEPARTMENT"] = "fire-department";
  CoverType["LOSS_DATA"] = "loss-data";
  CoverType["REWARD_COVERAGE"] = "reward-coverage";
  CoverType["REFRIGERATION_BREAKDOWN"] = "refrigeration-breakdown";
  CoverType["OWNERS_GOODS_EXTENSION"] = "owners-goods-extension";
  CoverType["NON_OWNED_TRAILER"] = "non-owned-trailer";
  CoverType["NON_OWNED_TRAILER_NUMBER"] = "non-owned-trailer-number";
  CoverType["REUSABLE_PACKING_CONTAINERS"] = "reusable-packing-containers";
  CoverType["TARPS_CHAINS"] = "tarps-chains";
  CoverType["SUBHAULER_OWNER_OPERATOR"] = "subhauler-owner-operator";
  CoverType["POLLUTANT_CLEAN_UP"] = "pollutant-clean-up";
  CoverType["EXCESS_LEVEL"] = "excess-level";
  CoverType["CMR"] = "cmr";
  CoverType["DO_EXCESS_LEVEL"] = "do-excess-level";
  CoverType["BUSINESS_OWNERS_POLICY"] = "business-owners-policy";
  CoverType["AUTOMOBILE"] = "automobile";
  CoverType["EXCESS_LIABILITY"] = "excess-liability";
  CoverType["WORKERS_COMPENSATION"] = "workers-compensation";
  CoverType["COMMERCIAL_BOND"] = "commercial-bond";
  CoverType["FIDELITY"] = "fidelity";
  CoverType["DRIVERS_NEG"] = "drivers-neg";
  CoverType["CONTENTS"] = "contents";
  CoverType["COMPUTERS"] = "computers";
  CoverType["BUILDINGS"] = "buildings";
  CoverType["BI_ICOW"] = "bi-icow";
  CoverType["US_CLAIM"] = "us-claim";
  CoverType["PROPERTY"] = "property";
  CoverType["PACKAGE"] = "package";
  CoverType["COMPUTER_BREAKDOWN"] = "computer-breakdown";
  CoverType["MONEY_ASSAULT"] = "money-assault";
  CoverType["SUBSIDENCE_EXCESS"] = "subsidence-excess";
  CoverType["BI_EXCESS"] = "bi-excess";
  CoverType["PROPERTY_EXCESS"] = "property-excess";
  CoverType["PE_EXCESS"] = "pe-excess";
  CoverType["CEAL_PERCENTAGE"] = "ceal_percentage";
  CoverType["PROFESSIONAL_INDEMNITY_CLAIM"] = "professional-indemnity-claim";
  CoverType["PI_WAIVER_OF_SUBROGATION"] = "pi-waiver-of-subrogation";
  CoverType["PI_CONTINGENT_BODILY_INJURY"] = "pi-contingent-bodily-injury";
  CoverType["PUBLIC_LIABILITY_CLAIM"] = "public-liability-claim";
  CoverType["PL_TERRORISM"] = "pl-terrorism";
  CoverType["PL_PROPERTY_AND_EQUIPMENT"] = "pl-property-and-equipment";
  CoverType["PL_HIRED_NON_OWNED_AUTO"] = "pl-hired-non-owned-auto";
  CoverType["PL_WAIVER_OF_SUBROGATION"] = "pl-waiver-of-subrogation";
  CoverType["PL_PRIMARY_NON_CONTRIBUTORY"] = "pl-primary-non-contributory";
  CoverType["CL_EXCESS"] = "cl-excess";
  CoverType["CL_TERRORISM"] = "cl-terrorism";
  CoverType["CL_MEDIA_LIABILITY"] = "cl-media-liability";
  CoverType["BUSINESS_OWNERS_POLICY_CLAIM"] = "business-owners-policy-claim";
  CoverType["CRIME"] = "crime";
  CoverType["CRIME_EXCESS"] = "crime-excess";
  CoverType["BOP_TERRORISM"] = "bop-terrorism";
  CoverType["BOP_HIRED_NON_OWNED_AUTO"] = "bop-hired-non-owned-auto";
  CoverType["BOP_HIRED_NON_OWNED_AUTO_EXCESS"] = "bop-hired-non-owned-auto-excess";
})(CoverType || (CoverType = {}));